import { Transform } from '../math/Transform';
export class Transformable {
    constructor() {
        this.transform = new Transform();
    }
}
//# sourceMappingURL=Transformable.js.map